import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { initialiseLaunchpadAnalytics } from '@moonpig/web-core-analytics'

export const LAUNCHPAD_ANALYTICS_EXPERIMENT =
  'enablement-web-launchpad-analytics'

export const useLaunchpadAnalyticsExperiment = () => {
  const isLaunchpadAnalytics =
    useExperiment(LAUNCHPAD_ANALYTICS_EXPERIMENT, { fallback: 'control' }) ===
    'variant'

  if (isLaunchpadAnalytics) {
    initialiseLaunchpadAnalytics()
  }

  return isLaunchpadAnalytics
}
